import { jsx as _jsx } from "react/jsx-runtime";
import Header from "../common";
import DrawerListManageTrips from "./DrawerListManageTrips";
var ManageTripsHeader = function (_a) {
    var layoutType = _a.layoutType;
    return (_jsx(Header, { layoutType: layoutType, title: "CorpTrip", showCreateButton: false, drawerContent: _jsx(DrawerListManageTrips, {}) }));
};
export default ManageTripsHeader;
